/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DecorFilter = {
    INSCRIPTION: 'INSCRIPTION',
    DECORED: 'DECORED'
} as const;
export type DecorFilter = typeof DecorFilter[keyof typeof DecorFilter];

